// extracted by mini-css-extract-plugin
module.exports = {"grid":"NewsGrid_grid__SIguJ"};